import { AxiosError } from "axios";

const createQueryFn = <TRes, TReq>(queryFn: (args: TReq) => Promise<TRes>) => {
  return async (args: TReq) => {
    try {
      const data = await queryFn(args);
      return { data };
    } catch (error: unknown) {
      try {
        const axiosError = error as AxiosError<{ message: string }>;
        // Use FetchBaseQueryError shape
        if (axiosError.response) {
          return { error: { status: axiosError.response!.status || 500, data: axiosError.response!.data?.message || "Okänt serverfel" } };
        }
        if (axiosError.request) {
          return { error: { status: 0, data: "Servern svarade inte" } };
        }
      } catch (e) {
        console.error(e);
      }

      return { error: { status: 0, data: "Okänt fel" } };
    }
  };
};

export default createQueryFn;
